import colors from 'constants/colors';
import { sanitizeHtml } from 'helpers/utils';
import { useForm } from 'react-final-form';

export const HeaderContent = () => {
  const form = useForm();
  const setTitle = form.getFieldState('set_title')?.value || '';
  const setDesc = form.getFieldState('set_desc')?.value || '';
  const primaryColor = form.getFieldState('primary_color')?.value || colors.inkBlue;
  const secondaryColor = form.getFieldState('secondary_color')?.value || colors.oathBlue;
  const setPages = form.getState().values?.set_pages;
  const issuesCount =
    typeof setPages === 'object' && setPages !== null ? Object.keys(setPages).length : 0;

  return (
    <>
      <span className="header-preview-title h2-dtm" style={{ color: secondaryColor }}>
        {setTitle}
      </span>
      <span
        className="header-preview-description body-text"
        style={{ color: secondaryColor }}
        dangerouslySetInnerHTML={{ __html: sanitizeHtml(setDesc) }}
      />
      {form.getState().values?.display_fundraising_bar && (
        <div className="header-preview-slider-container">
          <div className="header-preview-slider-texts">
            <span className="h3-dtm" style={{ color: secondaryColor }}>
              $_,___,___{' '}
              <span className="body-small-text" style={{ color: secondaryColor }}>
                of $... {form.getState().values?.goal_alt || 'Goal'}
              </span>
            </span>
            <span className="body-small-text" style={{ color: secondaryColor }}>
              ... donations
            </span>
          </div>
          <div
            className="header-preview-slider-track"
            style={{
              background: `linear-gradient(to right, ${primaryColor} 75%, ${colors.mercury} 75%)`,
            }}
          />
          <div className="header-preview-slider-texts">
            <span className="body-small-text" style={{ color: secondaryColor }}>
              Updated at ...
            </span>
            {form.getState().values?.hide_recent_location && (
              <span className="body-small-text" style={{ color: secondaryColor }}>
                Just donated from ...
              </span>
            )}
          </div>
        </div>
      )}
      {form.getState().values?.show_header_button !== false && (
        <>
          <div
            className="header-preview-button"
            style={{ backgroundColor: secondaryColor, color: primaryColor }}
          >
            {form.getState().values?.donate_custom_1 || `DONATE TO ALL ${issuesCount} ISSUES`}
          </div>
          <span className="body-small-text" style={{ color: secondaryColor }}>
            {form.getState().values?.donate_custom_1_helper || 'Donate'}
          </span>
        </>
      )}
    </>
  );
};
